import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, ArrowRight } from 'lucide-react';

const inr = (n) => `₹${Number(n).toLocaleString('en-IN')}`;

export const UpgradeNudge = ({ currentValue, allAccessPrice, onSwitch, testId = 'upgrade-nudge' }) => {
  const extra = Math.max(allAccessPrice - currentValue, 0);
  const cta = 'Switch to All-Access';
  return (
    <div className="rounded-xl border border-amber-500/30 bg-gradient-to-br from-amber-500/10 to-transparent p-4" data-testid={testId}>
      <p className="text-amber-300 font-semibold flex items-center gap-2 text-sm"><Crown className="w-4 h-4" /> Get everything for {extra > 0 ? `just ${inr(extra)} more` : 'about the same'}</p>
      <p className="text-zinc-400 text-xs mt-1">You're at {inr(currentValue)} with Basic + features. All-Access ({inr(allAccessPrice)}/year) unlocks every Pro feature.</p>
      {onSwitch ? (
        <button type="button" onClick={onSwitch} className="mt-3 text-sm text-amber-300 hover:text-amber-200 font-medium flex items-center gap-1" data-testid={`${testId}-btn`}>{cta} <ArrowRight className="w-4 h-4" /></button>
      ) : (
        <Link to="/pricing?plan=all_access_1y" className="mt-3 text-sm text-amber-300 hover:text-amber-200 font-medium inline-flex items-center gap-1" data-testid={`${testId}-btn`}>{cta} <ArrowRight className="w-4 h-4" /></Link>
      )}
    </div>
  );
};
